module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_21.6548d5df.mp3";